
import React, { useEffect, useState } from "react";
import fetchBase from "../utils/fetchBase";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
pdfjsLib.GlobalWorkerOptions.workerSrc =
  `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;


const EmployeePdfPage = ({ page, pageIndex, fields, fieldValues, setFieldValues }) => {
  const canvasRef = React.useRef(null);
  const viewport = page.getViewport({ scale: 1.2 });

  React.useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    page.render({ canvasContext: ctx, viewport });
  }, [page]);




  return (
    <div style={{ position: "relative", marginBottom: "20px" }}>
      <canvas ref={canvasRef} />

      {fields
        .filter(f => (f.pageNumber ?? f.page) === pageIndex)
        .map(f => (
          <input
            key={f.id}
            type="text"
            value={fieldValues[f.id] || ""}
            onChange={(e) =>
              setFieldValues(prev => ({ ...prev, [f.id]: e.target.value }))
            }
            style={{
              position: "absolute",
              top: (f.yCoordinate ?? f.ycoordinate) + -25,
              left: f.xCoordinate ?? f.xcoordinate,
              width: "200px",
              padding: "4px 6px",
              border: "1px solid #0071e3",
              borderRadius: "4px",
              fontSize: "12px"
            }}
          />
        ))}
    </div>
  );
};


const ApplyPage = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [pdfDoc, setPdfDoc] = useState(null);
  const [pdfPages, setPdfPages] = useState([]);
  const [fields, setFields] = useState([]);

  const [emailMatch, setEmailMatch] = useState(true);
  const [emailValid, setEmailValid] = useState(true);

  const [fieldValues, setFieldValues] = useState({});
  const [resumeFile, setResumeFile] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);





  useEffect(() => {
      fetch(`${fetchBase}/api/applications/public/active`)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to load applications.");
          return res.json();
        })
        .then((data) => {
          setApplications(data);
          setLoading(false);

          const params = new URLSearchParams(window.location.search);
          const autoId = params.get("applicationId");
          if (autoId) {
            const match = data.find((a) => String(a.id) === autoId);
            if (match) openApplication(match);
          }
        })
        .catch((err) => {
          setError(err.message);
          setLoading(false);
        });
    }, []);

  const openApplication = async (app) => {
      setSelectedApp(app);
      setShowModal(true);

      if (app.type === "CREATED_APP") {
        // Load created form fields
        const fieldsRes = await fetch(`${fetchBase}/api/applications/created-form/${app.id}/fields`);
        const fieldsData = await fieldsRes.json();
        setFields(fieldsData);

        const initialValues = {};
        fieldsData.forEach(f => { if (f.fieldType !== "section") initialValues[f.id] = ""; });
        setFieldValues(initialValues);
      } else {
        // Load PDF
        const url = `${fetchBase}/api/applications/file/${app.filename}?applicationId=${app.id}`;
        const doc = await pdfjsLib.getDocument({ url }).promise;
        setPdfDoc(doc);

        const pages = [];
        for (let i = 1; i <= doc.numPages; i++) {
          pages.push(await doc.getPage(i));
        }
        setPdfPages(pages);

        const fieldsRes = await fetch(`${fetchBase}/api/applications/${app.id}/fields`);
        const fieldsData = await fieldsRes.json();
        setFields(fieldsData);

        const initialValues = {};
        fieldsData.forEach(f => initialValues[f.id] = "");
        setFieldValues(initialValues);
      }
    };

  const handleSubmitApplication = async () => {

        if (!resumeFile) {
          alert("Please upload your resume (PDF) before submitting.");
          return;
        }

        const uncheckedCheckbox = fields.find(
          (f) => f.fieldType === "checkbox" && !fieldValues[f.id]
        );
        if (uncheckedCheckbox) {
          alert("Please review and accept the required authorization before submitting.");
          return;
        }


      // Email match validation
      if (fieldValues.email && fieldValues.confirmEmail) {
          if (fieldValues.email !== fieldValues.confirmEmail) {
              alert("Email addresses do not match.");
              return;
          }
      }

      // Phone formatting already handled above

      if (selectedApp.type === "CREATED_APP") {
        // Build payload keyed by field label
        const payload = {};
        fields.forEach(f => {
          if (f.fieldType !== "section") {
            payload[f.fieldLabel] = fieldValues[f.id] || "";
          }
        });

          const formData = new FormData();
          formData.append("resume", resumeFile);
          formData.append("payload", JSON.stringify(payload));

          const res = await fetch(`${fetchBase}/api/applications/created-form/${selectedApp.id}/submit`, {
              method: "POST",
              body: formData
          });

          if (!res.ok) {
              alert("Something went wrong. Please try again.");
              return;
          }

      } else {
        const payload = {
          applicationId: selectedApp.id,
          responses: fieldValues
        };

       const formData = new FormData();
       formData.append("resume", resumeFile);
       formData.append("payload", JSON.stringify(payload));

       const res = await fetch(`${fetchBase}/api/applications/submit`, {
           method: "POST",
           body: formData
       });

       if (!res.ok) {
           alert("Something went wrong. Please try again.");
           return;
       }

      }

      setSubmitSuccess(true);
        setTimeout(() => {
          setSubmitSuccess(false);
          setShowModal(false);
        }, 3000);
    };





  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "40px",
        backgroundImage: "url('/images/background1.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >

      <h1 style={{ fontSize: "32px", fontWeight: "600", marginBottom: "8px" }}>
        Open Positions
      </h1>
      <p style={{ fontSize: "14px", marginBottom: "20px", color: "#1d1d1f" }}>
        Select an organization to view and complete their application.
      </p>


      {loading && <p>Loading...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {applications.map((app) => (
          <div
            key={app.id}
            onClick={() => openApplication(app)}
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "24px",
              width: "280px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              cursor: "pointer",
              transition: "box-shadow 0.2s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.14)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)")
            }
          >
            <p style={{ fontWeight: "600", fontSize: "16px", marginBottom: "6px", color: "#1d1d1f" }}>
              {app.organizationName}
            </p>

            <p style={{ color: "#555", fontSize: "14px" }}>
                {app.position}{app.location ? ` (${app.location})` : ""}
            </p>

          </div>
        ))}

        {!loading && !error && applications.length === 0 && (
          <p style={{ color: "#fff" }}>No open positions at this time.</p>
        )}
      </div>

  {showModal && selectedApp && (
    <div className="modal-overlay">
          <div className="modal-box review-mode" style={{ overflowY: "auto", maxHeight: "90vh" }}>

        <button
          className="modal-close"
          onClick={() => { setSubmitSuccess(false); setShowModal(false); }}
        >
          X
        </button>

        {submitSuccess ? (
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px 20px",
            textAlign: "center",
            gap: "16px"
          }}>
            <div style={{
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              background: "#34c759",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px",
              color: "#fff"
            }}>✓</div>
            <h2 style={{ fontSize: "18px", fontWeight: "700", color: "#1d1d1f", margin: 0 }}>
              Application Received
            </h2>
            <p style={{ fontSize: "13px", color: "#6e6e73", margin: 0, lineHeight: "1.6" }}>
              Thank you for your application. Our team will review your submission and reach out to you if your qualifications align with our current needs. We appreciate your interest.
            </p>
          </div>
        ) : (
          <>

        <h2 style={{ color: "#1d1d1f", marginBottom: "2px", fontSize: "18px", fontWeight: "700" }}>
          {selectedApp.organizationName}
        </h2>
        <p style={{ fontSize: "13px", color: "#6e6e73", marginBottom: "12px" }}>
          Application for {selectedApp.position}
        </p>

        {/* Location */}
        {selectedApp.location && (
          <p style={{ fontSize: "13px", color: "#6e6e73", marginBottom: "12px" }}>
            Location: <strong>{selectedApp.location}</strong>
          </p>
        )}

        {/* CREATED_APP form */}
        {selectedApp.type === "CREATED_APP" && (
          <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "16px" }}>
            {fields.map((f) => (
              f.fieldType === "section" ? (

                <p
                  key={f.id}
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#1d1d1f",
                    margin: "8px 0 0 0",
                    borderBottom: "1px solid #e0e0e0",
                    paddingBottom: "4px"
                  }}
                >
                  {f.fieldLabel}
                </p>

              ) : f.fieldType === "note" ? (

                <p
                  key={f.id}
                  style={{
                    fontSize: "11px",
                    color: "#8e8e93",
                    lineHeight: "1.5",
                    marginTop: "2px",
                    marginBottom: "4px"
                  }}
                >
                  {f.fieldLabel}
                </p>

              ) : f.fieldType === "checkbox" ? (

                <label
                  key={f.id}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "8px",
                    fontSize: "12px",
                    color: "#1d1d1f",
                    marginTop: "2px"
                  }}
                >
                  <input
                    type="checkbox"
                    checked={fieldValues[f.id] || false}
                    onChange={(e) =>
                      setFieldValues(prev => ({
                        ...prev,
                        [f.id]: e.target.checked
                      }))
                    }
                    style={{
                      marginTop: "2px"
                    }}
                  />

                  <span>{f.fieldLabel}</span>
                </label>

              ) : f.fieldType === "signature" ? (

                <div
                  key={f.id}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px"
                  }}
                >
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#6e6e73",
                      fontWeight: "500"
                    }}
                  >
                    {f.fieldLabel}
                  </label>

                  <input
                    type="text"
                    placeholder="Type Full Legal Name"
                    value={fieldValues[f.id] ?? ""}
                    onChange={(e) =>
                      setFieldValues(prev => ({
                        ...prev,
                        [f.id]: e.target.value
                      }))
                    }
                    style={{
                      padding: "8px",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      fontSize: "13px"
                    }}
                  />

                  <p
                    style={{
                      fontSize: "11px",
                      color: "#8e8e93",
                      margin: 0
                    }}
                  >
                    Date signed will be recorded automatically upon submission.
                  </p>
                </div>

              ) : (

                <div
                  key={f.id}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px"
                  }}
                >
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#6e6e73",
                      fontWeight: "500"
                    }}
                  >
                    {f.fieldLabel}
                  </label>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px"
                    }}
                  >
                    <input
                      type={f.fieldLabel.toLowerCase() === "email" ? "email" : "text"}
                      value={fieldValues[f.id] ?? ""}
                      onChange={(e) => {
                        let v = e.target.value;

                        if (f.fieldLabel.toLowerCase().includes("phone")) {
                          v = v.replace(/\D/g, "");

                          if (v.length > 10) {
                            v = v.slice(0, 10);
                          }

                          if (v.length >= 7) {
                            v = `(${v.slice(0,3)}) ${v.slice(3,6)}-${v.slice(6)}`;
                          } else if (v.length >= 4) {
                            v = `(${v.slice(0,3)}) ${v.slice(3)}`;
                          } else if (v.length >= 1) {
                            v = `(${v}`;
                          }
                        }

                        if (f.fieldLabel.toLowerCase() === "email") {
                          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                          setEmailValid(emailPattern.test(v));
                          setEmailMatch(v === fieldValues.confirmEmail);
                        }

                        setFieldValues(prev => ({
                          ...prev,
                          [f.id]: v
                        }));
                      }}
                      style={{
                        padding: "8px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        fontSize: "13px",
                        flex: 1
                      }}
                    />

                    {f.fieldLabel.toLowerCase() === "email" && fieldValues[f.id] && (
                      <span
                        style={{
                          color: emailMatch && emailValid ? "#34c759" : "#ff3b30",
                          fontWeight: "700",
                          fontSize: "14px",
                          flexShrink: 0
                        }}
                      >
                        {emailMatch && emailValid ? "✓" : "✕"}
                      </span>
                    )}
                  </div>

                  {f.fieldLabel.toLowerCase() === "email" && (
                    <div style={{ marginTop: "8px" }}>
                      <label
                        style={{
                          fontSize: "12px",
                          color: "#6e6e73",
                          fontWeight: "500",
                          display: "block",
                          marginBottom: "4px"
                        }}
                      >
                        Confirm Email
                      </label>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        <input
                          type="email"
                          placeholder="Confirm Email"
                          value={fieldValues.confirmEmail ?? ""}
                          onChange={(e) => {
                            const v = e.target.value;

                            setFieldValues(prev => ({
                              ...prev,
                              confirmEmail: v
                            }));

                            setEmailMatch(v === fieldValues[f.id]);
                          }}
                          style={{
                            padding: "8px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            fontSize: "13px",
                            flex: 1
                          }}
                        />

                        {fieldValues.confirmEmail && (
                          <span
                            style={{
                              color: emailMatch ? "#34c759" : "#ff3b30",
                              fontWeight: "700",
                              fontSize: "14px",
                              flexShrink: 0
                            }}
                          >
                            {emailMatch ? "✓" : "✕"}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </div>

              )
          ))}
        </div>
      )}

  {/* Resume Upload */}
    <div style={{ marginTop: "12px", display: "flex", flexDirection: "column", gap: "4px" }}>
      <label style={{ fontSize: "12px", color: "#6e6e73", fontWeight: "500" }}>
        Upload Resume (PDF)
      </label>

      <input
        type="file"
        accept="application/pdf"
        onChange={(e) => {
          const file = e.target.files?.[0] || null;
          setResumeFile(file);
        }}
        style={{
          padding: "6px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          fontSize: "13px",
          backgroundColor: "#f9f9f9"
        }}
      />
    </div>


        {/* PDF Viewer for PDF_APP */}
        {selectedApp.type !== "CREATED_APP" && (
          <div
            style={{
              width: "100%",
              height: "520px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              marginBottom: "16px",
              overflowY: "auto",
              position: "relative"
            }}
          >
            {pdfPages.map((page, pageIndex) => (
              <EmployeePdfPage
                key={pageIndex}
                page={page}
                pageIndex={pageIndex}
                fields={fields}
                fieldValues={fieldValues}
                setFieldValues={setFieldValues}
              />
            ))}
          </div>
        )}

        {/* Submit Button */}
        <button
          onClick={handleSubmitApplication}
          style={{
            padding: "8px 16px",
            backgroundColor: "#1d1d1f",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            width: "100%"
          }}
        >
          Submit Application
        </button>

          </>
        )}

      </div>
    </div>
  )}


    </div>
  );
};

export default ApplyPage;